export default class PasswordVisibilitySwitcher {
  constructor(input) {
    this.input = input.querySelector("input");
    this.switcherButton = input.querySelector(".show-password-register");
    this.isVisible = false;

    this.init();
  }

  init = async () => {
    await this.initListeners();
  };

  handleClick = () => {
    this.isVisible === false ? (this.input.type = "text") : (this.input.type = "password");

    this.switcherButton.classList.toggle("mix-blend-hard-light");
    this.isVisible = !this.isVisible;
  };

  initListeners = () => {
    return new Promise((resolve, reject) => {
      this.switcherButton.addEventListener("click", this.handleClick);

      resolve();
    });
  };
}
